import { Routes, Route } from "react-router-dom";
import IndexFour from "./index/index-four";
import AboutApp from "./pages/AboutApp";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import SmoothScroll from "./components/smooth-scroll";

function App() {
  return (
    <>
      <SmoothScroll />
      <Routes>
        <Route path="/" element={<IndexFour />} />
        <Route path="/about-app" element={<AboutApp />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
      </Routes>
    </>
  );
}

export default App;
